import React from 'react';
import PropTypes from 'prop-types';

import { BET_BUILDER_TYPE_ID } from '@tickets/constants';

const BetType = ({ data }) => {
  const swarm = data?.dataFromSwarm;
  const typeName = swarm?.type_name;
  const isBetBuilder = swarm?.type_id === BET_BUILDER_TYPE_ID;

  return (
    <div className="ticket-type">
      <p>{typeName ?? '-'}</p>
      {isBetBuilder && <span className="ticket-bb-badge">{'BB'}</span>}
    </div>
  );
};

export default BetType;

BetType.propTypes = {
  data: PropTypes.object,
};
